<!-- 学习效力-学习策略分析 -->
<!-- 认知，情感，行为倾向，学习动力... 等 -->
<template>
    <div class="part3_1_main_box">
        <P class="main_title">{{index}}、{{title}}{{name}}</P>
        <div class="main_norm_box">
            <div class="norm_box" :style="{width: normObj.score/200*692  + 'px'}" >
                <div class="norm_score">
                    <p class="score">{{normObj.score | toFixed(1)}}</p>
                </div>
                <div class="norm_block" :style="{left: normData.l_norm/200*692 + 'px', width: (normData.r_norm-normData.l_norm)/200*692 + 'px' }" :title="normData.l_norm + '~' + normData.r_norm"></div>
            </div>
        </div>
        <p class="main_detail">你在{{normObj.name}}的水平值为<span class="color2">{{normObj.score | toFixed(1)}}分</span>，水平为
            <span :class="this.getColor(normObj.score )">{{this.getGrade(normObj.score )}}</span>，
            你超过了<span class="color2">{{normObj.percent*100 | toFixed(1)}}%</span>的人。
        </p>
        <P class="main_directions">{{comment.comment}}</P>
    </div>
</template>
<script>
export default {
    name: 'page_part3_main',
    components: {  },
    props: {
        index: {
        },
        normData: {
        },
        normObj: {
            type: Object//norm数组的其中一项
            // required: true
        },
        comment: {
            type: Object//comment的类型解读
            // required: true
        },
        title: {
            type: String
        },
        name: {
            type: String
        },
        type: {
            type: String
        }
    },
    data() {
        return {
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
        // [0,75)[75,92)[92,108)[108,125)[125,200]
        getColor(value) {
            if(value < 75) {
                return 'color1';
            }else if(value < 92) {
                return 'color2';
            }else if(value <= 108) {
                return 'color3';
            }else if(value <= 125) {
                return 'color4';
            }else {
                return 'color5';
            }
        },
        getGrade(value) {
            if(value < 75) {
                return '低';
            }else if(value < 92) {
                return '较低';
            }else if(value <= 108) {
                return '中等';
            }else if(value <= 125) {
                return '较高';
            }else {
                return '高';
            }
        }
    }
}
</script>
<style type="text/css" lang='less' scoped>
@import './report.less';
.part3_1_main_box {
    margin-bottom: 60px;
    .part3_score_1 {
        background: url(~@/assets/report_imgs/icon_part3type1.png) no-repeat center center;
    }
    .part3_score_2 {
        background: url(~@/assets/report_imgs/icon_part3type2.png) no-repeat center center;
    }
    .part3_score_3 {
        background: url(~@/assets/report_imgs/icon_part3type3.png) no-repeat center center;
    }
    .c_score_tyep1 {
        color: #ff9f7b;
    }
    .c_score_tyep2 {
        color: #e77178;
    }
    .c_score_tyep3 {
        color: #41cbaa;
    }
    .main_title {
        display: flex;
        align-items: center;
        //color: #F6A724;
        font-size: 16px;
        font-weight: bold;
        //.block {
        //	width: 10px;
        //	height: 10px;
        //	margin-right: 5px;
        //	border-radius: 2px;
        //	background-color: #F6A724;
        //}
        .name1 {
            color: #ff9f7b;
        }
        .name2 {
            color: #E8777E;
        }
        .name3 {
            color: #19ADA7;
        }
    }
    .gradeName {
        margin-bottom: 35px;
        font-size: 14px;
        span {
            font-size: 16px;
            font-weight: bold;
        }
        .score1 {
            color: #FF9F7B;
        }
        .score2 {
            color: #FA8AA5;
        }
        .score3 {
            color: #46CCAC;
        }
    }
    .main_directions {
        padding: 15px;
        font-size: 14px;
        color: #8A8A8A;
        line-height: 28px;
        background-color: #F7F7F7;
        border-radius: 5px;
    }
}
</style>
